import React, {
    FC,
} from 'react';
import {
    BrowserRouter,
    Route,
    Routes,
} from 'react-router-dom';

import {
    useRedirectProtocol,
} from 'tools/hooks';

import Payment from './pages/Payment';

const App: FC = () => {
    useRedirectProtocol();

    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path={'/:encodedId'}
                    element={<Payment/>}
                />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
